import { ShoppingListProduct } from 'src/types/shopping_lists/ShoppingList';
import {
  ShoppingListExportTranslateFn,
  defaultShoppingListExportTranslate,
  exportShoppingListsToExcel,
} from './exportShoppingListsToExcel';

export const exportShoppingListProducts = async (
  listName: string,
  products: ShoppingListProduct[],
  t: ShoppingListExportTranslateFn = defaultShoppingListExportTranslate
): Promise<void> => {
  await exportShoppingListsToExcel([{ listName, products }], t);
};
